<template>
  <tr>
    <td class="fixed-column">
      <v-checkbox
        v-model="selected"
        class="layout align-center justify-center row fill-height changes-checkbox ml-2"
        @change="$emit('select', item.id)"
      />
    </td>
    <template v-for="(column, colIndex) in headers">
      <td :key="colIndex">
        <span
          v-if="column.component === 'decimal'"
          @click="setEditDialog(column, true)"
        >
          <v-edit-dialog
            v-if="decimalDialog && column.editor"
            ref="decimal-dialog"
            v-model="decimalDialog"
            lazy
            large
            cancel-text="Отмена"
            save-text="Ок"
            @cancel="closeDialog(column)"
            @open="editingValue = item[column.name]"
            @save="save(column, item)"
          >
            <div class="link">{{ item[column.name] }}</div>
            <template v-slot:input>
              <DecimalEditor
                v-model="item[column.name]"
                :scale="3"
                class="ma-2"
              />
            </template>
          </v-edit-dialog>
          <span
            v-else
            :class="[
              disabled ? '' : 'link',
              (column.name === 'weightNetto' || column.name === 'weightBrutto')
                && item[column.name] === 0
                ? 'red--text'
                : ''
            ]"
          >{{
            item[column.name]
          }}</span>
        </span>
        <span
          v-if="column.component === 'reference'"
          @click="setEditDialog(column, true)"
        >
          <v-edit-dialog
            v-if="referenceDialog && column.editor"
            ref="reference-dialog"
            v-model="referenceDialog"
            lazy
            large
            cancel-text="Отмена"
            save-text="Ок"
            @cancel="closeDialog(column)"
            @open="editingValue = item[column.name]"
            @save="save(column, item)"
          >
            <div :class="[disabled ? '' : 'link']">
              {{ item[column.name] ? item[column.name].title : "_" }}
            </div>
            <template v-slot:input>
              <app-reference
                v-model="item[column.name]"
                class="ma-2"
                :resource="column.resource"
                :component-name="column.referenceComponent"
                outline
                :height-field="44"
                :disabled="disabled"
              />
            </template>
          </v-edit-dialog>
          <span
            v-else
            :class="[disabled ? '' : 'link']"
          >{{
            item[column.name] && item[column.name].title
              ? item[column.name].title
              : "_"
          }}</span>
        </span>
        <span
          v-if="column.component === 'text'"
          @click="setEditDialog(column, true)"
        >
          <v-edit-dialog
            v-if="textDialog && column.editor"
            ref="text-dialog"
            v-model="textDialog"
            lazy
            large
            cancel-text="Отмена"
            save-text="Ок"
            @cancel="closeDialog(column)"
            @open="editingValue = item[column.name]"
            @save="save(column, item)"
          >
            <div :class="[disabled ? '' : 'link']">
              {{ item[column.name] || "_" }}
            </div>
            <template v-slot:input>
              <v-text-field
                v-model="item[column.name]"
                class="ma-2"
                outline
                height="44"
                hide-details
              />
            </template>
          </v-edit-dialog>
          <span
            v-else
            :class="[disabled ? '' : 'link']"
          >{{
            item[column.name] || "_"
          }}</span>
        </span>
        <span v-else-if="column.type === 'object'">{{
          item[column.name] ? item[column.name].title : ""
        }}</span>
        <span v-else-if="column.type === 'link'">
          <template v-if="item.goodSite">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  :href="createUrl(item[column.name])"
                  target="_blank"
                  style="text-decoration: none;"
                  v-on="on"
                >
                  <v-icon small>language </v-icon>
                </a>
              </template>
              <span>{{ item[column.name] }}</span>
            </v-tooltip>
          </template>
          <template v-else>
            <v-icon
              small
              disabled
            >
              language
            </v-icon>
          </template>
        </span>
        <span v-else-if="column.type === 'menu'">
          <slot name="prepend-cell" />
        </span>
        <span v-else-if="column.type === 'order'">
          {{ order }}
        </span>
        <span v-else-if="!column.component">{{ item[column.name] }}</span>
      </td>
    </template>
  </tr>
</template>
<script>
export default {
  props: ["columns", "value", "order", "disabled", "selected"],
  data() {
    return {
      decimalDialog: false,
      referenceDialog: false,
      textDialog: false,
      editingValue: null,
      headers: [],
      item: null,
    };
  },
  watch: {
    columns: {
      handler(value) {
        if (value) {
          this.headers = value;
        }
      },
      immediate: true,
    },
    value: {
      handler(value) {
        if (value) {
          this.item = value;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.$watch(
      () => {
        return this.decimalDialog;
      },
      newVal => {
        if (newVal) {
          this.$refs["decimal-dialog"][0].isActive = true;
        }
      },
    );
    this.$watch(
      () => {
        return this.referenceDialog;
      },
      newVal => {
        if (newVal) {
          this.$refs["reference-dialog"][0].isActive = true;
        }
      },
    );
    this.$watch(
      () => {
        return this.textDialog;
      },
      newVal => {
        if (newVal) {
          this.$refs["text-dialog"][0].isActive = true;
        }
      },
    );
  },
  methods: {
    setEditDialog(column, value) {
      if (this.disabled) {
        return;
      }
      if (column.component === "reference") {
        this.referenceDialog = value;
      }
      if (column.component === "decimal") {
        this.decimalDialog = value;
      }
      if (column.component === "text") {
        this.textDialog = value;
      }
      this.headers.find(h => h.name === column.name).editor = value;
    },
    closeDialog(column) {
      this.item[column.name] = this.editingValue;
      this.setEditDialog(column, false);
      this.editingValue = null;
      this.$emit("cancel");
    },
    save(column, item) {
      this.setEditDialog(column, false);
      this.$emit("change", item);
      this.editingValue = null;
    },
    createUrl(url) {
      const regEx = /http(?=s:\/\/|:\/\/)/;
      if (url && !regEx.test(url)) {
        return `https://${url}`;
      }
      return `${url}`;
    },
  },
};
</script>

<style>
</style>
